import DefaultElementNodeType from '../DefaultElementNodeType';
import {PHYSICAL_EQUIPMENT} from '../../metamodel/Concept';

export default class EquipmentNodeType extends DefaultElementNodeType {
	static get typeName() {
		return PHYSICAL_EQUIPMENT;
	}
}
